<template>
    <v-card>
        <v-card-text>
            <v-form lazy-validation ref="formRef" v-model="valid">
                <v-layout row wrap>
                    <FormErrorDisplayHandler v-if="errors.length" :errors="errors" class="mt-4" ref="errorRef"/>

                    <v-flex xs12 class="ml-0">
                        <v-radio-group v-model="trekkingData.isExtension" row>
                            <v-radio label="New" :value=false></v-radio>
                            <v-radio label="Extension" :value=true></v-radio>
                        </v-radio-group>
                    </v-flex>

                    <v-flex xs12 class="ml-0">
                        <v-select
                            outlined
                            hide-details
                            label="Select office * "
                            :items="offices"
                            :rules="[rules.required]"
                            item-value="slug"
                            item-text="label"
                            v-model="trekkingData.office"
                        />
                    </v-flex>

                    <confirmation-header-text class="ml-0" icon="mdi-alpha-t-box" text="Trekking Route:"/>

                    <v-flex class="pt-0" lg4 sm12>
                        <v-autocomplete
                            :items="trekkingRoutes"
                            :rules="[rules.required]"
                            item-text="name"
                            item-value="id"
                            label="Trekking Routes *"
                            outlined
                            hide-details
                            return-object
                            v-model="trekkingData.trekkingRoute"
                        />
                    </v-flex>

                    <v-flex class="pt-0" lg4 sm12 v-if="trekkingData.trekkingRoute">
                        <v-text-field
                            :error-messages="noOfDaysError"
                            label="Number of days *"
                            outlined
                            hide-details
                            type="number"
                            v-model="trekkingData.no_of_days"
                            onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"

                        />
                    </v-flex>

                    <v-flex class="pt-0" lg4 sm12>
                        <outlined-time-picker
                            :rules="trekkingData.isExtension ? [rules.required] : [rules.required,rules.afterTodayEng]"
                            label="Start Date (AD) *"
                            :hide-details="true"
                            v-model="trekkingData.starting_date"/>
                    </v-flex>

                    <v-flex v-if="trekkingData.trekkingRoute" class="pt-0" sm12>
                        <v-simple-table>
                            <thead>
                            <tr>
                                <th class="text-left" v-for="header in headers">{{ header.text }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr :key="item.name" v-for="item in trekkingData.trekkingRoute.extra.pricing">
                                <td>{{ months[item.from_month - 1] }}</td>
                                <td>{{ months[item.to_month - 1] }}</td>
                                <td>{{ trekkingData.trekkingRoute.min_days }}</td>
                                <td>USD {{ item.min_days_rate }}</td>
                                <td>USD {{ item.extend_per_day }}</td>
                            </tr>
                            </tbody>
                        </v-simple-table>

                    </v-flex>

                    <v-layout class="pt-0 mx-3" row wrap v-if="trekkingData.trekkingRoute">
                        <v-flex xs12>
                            <span class="font-weight-bold" style="font-size: 13px;">Routes Info</span>
                        </v-flex>
                        <div>

              <span class="font-weight-bold trekking-routes"
                    v-if="trekkingData.trekkingRoute.start_point">{{ trekkingData.trekkingRoute.start_point }}</span> -

                            <span v-for="point in trekkingData.trekkingRoute.entry_points" :key="point">
                <span class="font-weight-bold trekking-routes" v-if="point">{{ point }}</span> -
              </span>
                            <span class="font-weight-bold trekking-routes"
                                  v-if="trekkingData.trekkingRoute.end_point"> {{
                                    trekkingData.trekkingRoute.end_point
                                }}</span>
                        </div>
                    </v-layout>

                    <v-flex xs12>
                        <v-checkbox
                            label="Is Expedition?"
                            v-model="trekkingData.isExpedition"
                            :value="false"
                            hide-details
                        />
                    </v-flex>
                    <v-flex sm6 xs12 v-if="trekkingData.isExpedition">
                        <file-display style="margin-left: 150px"
                                      v-if="trekkingData && trekkingData.expedition_recommendation_file_url"
                                      :src="trekkingData.expedition_recommendation_file_url"></file-display>
                        <file-input
                            :show-image="true"
                            :required="!trekkingData.id ? true : false"
                            :label="!trekkingData.id ? 'Expedition Recommendation File (1MB) *' : 'Expedition Recommendation File (1MB) '"
                            :file-size="1024"
                            v-model="trekkingData.expedition_recommendation_file"
                        ></file-input>
                    </v-flex>

                    <confirmation-header-text class="ml-0" icon="mdi-account" text="Trekker's Info:"/>

                    <v-flex xs12 style="margin-top: -50px;">
                        <v-btn @click="addTrekker()" class="pull-right"
                               color="primary white--text" fab
                               x-small>
                            <v-icon>add</v-icon>
                        </v-btn>


                    </v-flex>

                    <template v-for="(trekker, i) in trekkingData.trekkers">
                        <v-flex :key="i+'trekker'" xs12 class="mb-3">
                            <v-card class="px-3 pb-4" outlined elevation="1">
                                <v-layout row wrap>
                                    <v-flex xs2>
                                        <confirmation-header-text :text="'Trekker '+ (i+1)"/>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-checkbox
                                            label="Indian without visa"
                                            v-model="trekker.indian_without_visa"
                                            :value="1"
                                            hide-details
                                        />
                                    </v-flex>
                                    <v-flex xs1 class="mt-4">
                                        <v-btn @click="trekkingData.trekkers.splice(i,1)" v-if="i+1 > 2"
                                               color="red white--text" fab
                                               x-small>
                                            <v-icon>cancel</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>

                                <v-layout v-if="trekker.indian_without_visa" class="pl-2" row wrap>
                                    <v-flex md3 xs12>
                                        <v-text-field
                                            label="Full Name *"
                                            :rules="[rules.required]"
                                            outlined
                                            hide-details
                                            type="text"
                                            v-model="trekker.full_name"
                                        />
                                    </v-flex>
                                    <v-flex md3 xs12>
                                        <new-date-picker
                                            min-year="1900"
                                            label="Date of birth(AD) *"
                                            v-model="trekker.dob"
                                            :max-year="max_year"
                                        />
                                    </v-flex>

                                    <v-flex md3 xs12>
                                        <v-text-field
                                            label="Email (Optional) "
                                            outlined
                                            hide-details
                                            type="email"
                                            v-model="trekker.email"
                                        />
                                    </v-flex>

                                    <v-flex md3 xs12>
                                        <v-select
                                            :items="genders"
                                            label="Gender *"
                                            :rules="[rules.required]"
                                            outlined
                                            hide-details
                                            v-model="trekker.gender"
                                        />
                                    </v-flex>

                                    <v-flex md3 xs12>
                                        <v-combobox
                                            :items="occupations"
                                            label="Select Occupation *"
                                            :rules="[rules.required]"
                                            outlined
                                            hide-details
                                            v-model="trekker.occupation"
                                        />
                                    </v-flex>

                                    <v-flex md3 xs12>
                                        <v-text-field
                                            :label="'Address of India *'"
                                            :rules="[rules.required]"
                                            outlined
                                            hide-details
                                            v-model="trekker.full_address"
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex md3 xs12>
                                        <v-text-field
                                            :label="'Contact no of India *'"
                                            prefix="+91"
                                            :rules="[rules.required]"
                                            min="0"
                                            outlined
                                            hide-details
                                            type="number"
                                            v-model="trekker.contact_no"
                                            onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                                        />
                                    </v-flex>

                                    <v-flex md3 xs12/>

                                    <v-flex md3 transition="scale-transition" xs12>
                                        <file-input
                                            :label="!trekkingData.id ? 'User Photo (1MB) *' :'User Photo (1MB)'"
                                            v-model="trekker.user_image"
                                            :required="!trekkingData.id ? true : false"
                                            :file-size="1024"
                                        />
                                    </v-flex>

                                    <confirmation-header-text class="ml-0" icon="mdi-passport" text="Document Detail:"/>

                                    <v-flex md4 xs12>
                                        <v-autocomplete
                                            :class="{'pr-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}"
                                            :items="document_types"
                                            label="Document Type *"
                                            :rules="[rules.required]"
                                            outlined
                                            hide-details
                                            v-model="trekker.passport_type"
                                            id="passportType"
                                        />
                                    </v-flex>
                                    <v-flex md4 transition="scale-transition" xs12>
                                        <v-text-field
                                            :rules="[rules.required]"
                                            label="Document number *"
                                            outlined
                                            hide-details
                                            type="text"
                                            v-model="trekker.passport_number"
                                        />
                                    </v-flex>

                                    <v-flex md4 xs12 v-if="showValidity(trekker.passport_type)">
                                        <new-date-picker
                                            :maxYear=getYearPreviousOrAfterCurrent(14)
                                            :minYear=getCurrentYearsubtwo()
                                            label="Document Valid Date *"
                                            v-model="trekker.passport_validity"
                                        />
                                    </v-flex>
                                    <v-flex md4 xs12>
                                        <file-input
                                            :label="!trekkingData.id ? 'Document Image (1MB) *' : 'Document Image (1MB) '"
                                            :required="!trekkingData.id ? true:false"
                                            :file-size="1024"
                                            v-model="trekker.passport_image"
                                        />
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap v-else class="pl-2">
                                    <v-flex :key="i+'submission_no'" md4 transition="scale-transition" xs12>
                                        <v-text-field
                                            :rules="[rules.required]"
                                            label="Visa Number/Submission ID *"
                                            outlined
                                            hide-details
                                            type="text"
                                            v-model="trekker.visa_number"
                                        />
                                    </v-flex>
                                    <v-flex :key="i+'passport_number'" md4 transition="scale-transition" xs12>
                                        <v-text-field
                                            :rules="[rules.required]"
                                            label="Passport number *"
                                            outlined
                                            hide-details
                                            type="text"
                                            v-model="trekker.passport_number"
                                        />
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-checkbox
                                            class="mt-0"
                                            label="Is Free?"
                                            v-model="trekker.isFree"
                                            :value="false"
                                            hide-details
                                        />
                                    </v-flex>
                                    <v-flex sm6 xs12 v-if="trekker.isFree">
                                        <file-input
                                            :show-image="true"
                                            :image-url="trekker.free_recommendation_file_url"
                                            :required="!trekkingData.id ? true : false"
                                            :label="!trekkingData.id ? 'Free Recommendation File (1MB) *' : 'Free Recommendation File (1MB) '"
                                            :file-size="1024"
                                            v-model="trekker.free_recommendation_file"
                                        ></file-input>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </template>

                    <!--          <v-flex xs12> <v-divider /> </v-flex>-->

                    <v-flex sm4 xs12>
                        <div v-if="trekkingData && trekkingData.iternary_file_url"
                             style="margin-left: 250px;margin-bottom: 10px">
                            <file-display :src="trekkingData.iternary_file_url"></file-display>
                        </div>
                        <span class="ml-5 pl-4 grey--text caption">Please upload Iternary with office stamp, pdf file only</span>
                        <file-input
                            :show-image="true"
                            :required="!trekkingData.id ? true : false"
                            :label="!trekkingData.id ? 'Iternary File (1MB) *' : 'Iternary File (1MB)'"
                            :file-size="1024"
                            :valid_file_types="['pdf']"
                            accept="application/pdf"
                            v-model="trekkingData.iternary_file"
                        />
                    </v-flex>

                    <confirmation-header-text class="ml-0" icon="mdi-account" text="Nepali Guide Info:"/>

                    <v-flex sm4 xs12>
                        <v-autocomplete
                            :items="guides"
                            :rules="[rules.selectRules]"
                            item-text="name"
                            item-value="id"
                            label="Select Guide *"
                            outlined
                            hide-details
                            return-object
                            v-model="trekkingData.nepaliGuide"
                        ></v-autocomplete>
                    </v-flex>

                    <v-flex sm4 xs12>
                        <div v-if="trekkingData && trekkingData.guides" style="margin-left: 250px;margin-bottom: 10px">
                            <file-display v-if="trekkingData && trekkingData.guides && trekkingData.guides.length>0"
                                          :src="trekkingData.guides[0].insurance_file"></file-display>
                        </div>
                        <file-input
                            :show-image="true"
                            :required="!trekkingData.id ? true : false"
                            :label="!trekkingData.id ? 'Guide Insurance (1MB) *' : 'Guide Insurance (1MB) '"
                            :file-size="1024"
                            v-model="trekkingData.nepaliGuide.file"

                        ></file-input>
                    </v-flex>

                    <confirmation-header-text class="ml-0" icon="mdi-account" text="Staff's Info:"/>

                    <v-flex sm4 xs12 transition="scale-transition">
                        <v-select
                            :items="porters"
                            item-value="id"
                            label="Select Staff "
                            multiple
                            outlined
                            hide-details
                            return-object
                            v-model="trekkingData.porter"
                        >
                            <template v-slot:selection="{ item, index }">
                                {{ item.name }}
                            </template>
                            <template v-slot:item="{ active, item, attrs, on }">
                                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                                    <v-list-item-action>
                                        <v-checkbox :input-value="active"></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <v-row no-gutters align="center">
                                                <span>{{ item.name + ' ( ' + item.designation + ' )' }}</span>
                                            </v-row>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-select>
                    </v-flex>

                    <v-flex sm4 xs12 v-if="trekkingData && trekkingData.porter.length > 0">
                        <div style="margin-left: 250px;margin-bottom: 10px">
                            <file-display
                                v-if="trekkingData && trekkingData.porters && trekkingData.porters.length > 0 "
                                :src="trekkingData.porters[0].insurance_file"></file-display>
                        </div>
                        <file-input
                            :show-image="true"
                            :image-url="trekkingData && trekkingData.porters && trekkingData.porters.length > 0  ? trekkingData.porters[0].insurance_file : null"
                            :required="!trekkingData.id ? true : false"
                            :label="!trekkingData.id ? 'Staff Insurance (1MB)*' : 'Staff Insurance (1MB)'"
                            v-model="trekkingData.staff_insurance"
                            :file-size="1024"
                        ></file-input>
                    </v-flex>

                    <!--          <v-flex md12 sm12 xs12>-->
                    <!--            <v-checkbox-->
                    <!--                label="Claim Exemption"-->
                    <!--                outlined-->
                    <!--                v-model="exemption"-->
                    <!--            ></v-checkbox>-->
                    <!--          </v-flex>-->

                    <!--          <v-flex xs6 v-if="exemption">-->
                    <!--            <file-input-->
                    <!--                label="Exemption Document"-->
                    <!--                v-model="trekkingData.exemption.file"-->
                    <!--            ></file-input>-->
                    <!--          </v-flex>-->

                    <!--          <v-flex md6 transition="scale-transition" xs6 v-if="exemption">-->
                    <!--            <v-text-field-->
                    <!--                :rules="[rules.required]"-->
                    <!--                label="Exemption Amount(USD) *"-->
                    <!--                outlined-->
                    <!--                type="number"-->
                    <!--                v-model="trekkingData.exemption.amount"-->
                    <!--                onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"-->

                    <!--            />-->
                    <!--          </v-flex>-->
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn v-if="trekkingData && trekkingData.id && trekkingData.id !== '' && trekkingData.id !== 'undefined'"
                   @click="update" color="blue darken-2" dark>Update
            </v-btn>
            <v-btn v-else @click="proceed" :loading="loading" color="blue darken-2" dark
                   :disabled="this.warnings.total_count && this.warnings.total_count > 0">Proceed
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<style scoped>
.section-header {
    font-size: 1.3em;
    font-weight: 500;
}

.trekking-routes {
    color: black;
    font-size: 13px;
    border: 1px solid black;
    padding: 15px;
    /*padding-left:15px;*/
    /*margin: 15px;*/
    margin-bottom: 10px;
    background-color: gainsboro;
    display: inline-block;
    height: 60px;
}

</style>
<script>
import {mapActions, mapGetters} from "vuex";
import Http from "axios";
import {API_URL, VERSION} from "../../config/config.js";
import FileInput from '../../components/FileInput'
import ConfirmationHeaderText from '../../components/ConfirmationHeaderText'
import FormErrorDisplayHandler from '../../components/FormErrorDisplayHandler'
import OutlinedTimePicker from "../../components/OutlinedDatePicker";
import NewDatePicker from "@/components/NewDatePicker";
import {validationMixin} from "../../mixins/validationMixin";
import FormattedDate from "../FormattedDate";
import AddressAutoComplete from "./AddressAutoComplete";
import {API_VERSION} from "../../config/config";

import moment from 'moment';
import FileDisplay from "@/components/FileDisplay";

export default {
    components: {
        FileDisplay,
        ConfirmationHeaderText,
        OutlinedTimePicker, FormErrorDisplayHandler,
        'file-input': FileInput,
        FormattedDate,
        AddressAutoComplete,
        NewDatePicker
    },
    props: ['type', 'trekkingPermitData'],
    data: () => ({
        valid: true,
        errors: [],

        headers: [
            {
                text: 'From Month',
                value: 'From month'
            },
            {
                text: 'To Month',
                value: 'To month'
            },
            {
                text: 'Min Days',
                value: 'Min Days rate'
            },
            {
                text: 'Min Cost',
                value: 'Min Cost'
            },
            {
                text: 'Extend Rate Per Day',
                value: 'Extended per day'
            },

        ],

        startDateMenu: false,
        trekkingRoutes: [],
        guides: [],
        porters: [],
        months: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        trekkingAgencies: [],
        trekkingAgencyLoading: false,
        search: null,
        exemption: false,
        offices: [{slug: 'DoI', label: 'KATHMANDU'}, {slug: 'IO03', label: 'POKHARA'}],
        genders: ['Male', 'Female', 'Rather not say'],
        occupations: [],
        document_types: ['Ordinary passport', 'Rasan card', 'Voter id'],
        max_year: new Date().toISOString().substr(0, 4),
        loading: false
    }),
    mixins: [validationMixin],
    computed: {
        ...mapGetters({
            trekkingData: 'TrekkingSingle/trekkingData',
            warnings: 'AuthUser/warnings',
            countries: "SingleTrekRequest/countries"
        }),
        trekkingData: {
            get() {
                return this.$store.state.TrekkingSingle.trekkingData;
            },
            set(value) {
                this.$store.commit('TrekkingSingle/setTrekkinData', value)
            }
        },
        noOfDaysError() {
            let error = 'Required';
            if (this.trekkingData.no_of_days) {
                if (Number(this.trekkingData.no_of_days) < Number(this.trekkingData.trekkingRoute.min_days) && this.trekkingData.isExtension == false) {
                    error = 'No of days cannot be less than ' + this.trekkingData.trekkingRoute.min_days;
                } else {
                    error = '';
                }
            }

            return error;
        },
    },
    methods: {
        ...mapActions("TrekkingSingle", ["resetState", "checkVisaValidity", "checkProceedVisaValidity", "updateTrekkingRequest"]),
        getCurrentYearsubtwo() {
            let currentYear = Number(new Date().toISOString().substr(0, 4)) - 2;
            return parseInt(currentYear);
        },
        getYearPreviousOrAfterCurrent(value) {
            let currentYear = new Date().toISOString().substr(0, 4);
            return parseInt(currentYear) + value;
        },
        calculateTrekkingPermitCharge() {
            let extraDays =
                this.trekkingData.no_of_days - this.trekkingData.trekkingRoute.min_days;
            let total = 0;
            total =
                total +
                this.trekkingData.trekkingRoute.min_days_rate +
                extraDays * this.trekkingData.trekkingRoute.extend_per_day;

            return total;
        },
        async proceed() {
            let last_date = moment(this.trekkingData.starting_date).add(this.trekkingData.no_of_days, "days").format("YYYY-MM-DD");
            let porters = this.trekkingData.porter;


            this.trekkingData.porter = porters;


            if (this.$refs.formRef.validate() && this.noOfDaysError === '') {
                let extra_data = {
                    last_date: last_date
                };
                this.loading = true;
                let getErrors = await this.checkProceedVisaValidity(extra_data);

                if (getErrors.length > 0) {
                    this.loading = false;
                    this.$store.commit("Notification/showError", 'Invalid form data');
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

                    this.errors = getErrors;
                } else {
                    this.loading = false;
                    this.$store.commit('TrekkingSingle/setNewRequestMade', true);
                    this.$router.push({name: "TrekkingRequestConfirm"});
                }
            } else {
                this.loading = false;
                this.$store.commit("Notification/showError", 'Invalid form data');
            }
        },
        async update() {
            let porters = this.trekkingData.porter;
            let last_date = moment(this.trekkingData.starting_date).add(this.trekkingData.no_of_days, "days").format("YYYY-MM-DD");


            this.trekkingData.porter = porters;


            if (this.$refs.formRef.validate() && this.noOfDaysError === '') {
                let extra_data = {
                    last_date: last_date
                };
                let getErrors = await this.checkProceedVisaValidity(extra_data);

                if (getErrors.length > 0) {
                    this.$store.commit("Notification/showError", 'Invalid form data');
                    document.body.scrollTop = 0; // For Safari
                    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

                    this.errors = getErrors;
                } else {
                    this.$store.commit('TrekkingSingle/setNewRequestMade', true);
                    this.updateTrekkingRequest()
                        .then(() => {
                            this.$store.commit('Notification/showSuccess', 'Trekking Request updated successfully');
                            this.$router.push({name: 'TrekkingRequestList'});
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                            }
                        });
                }

            } else {
                this.$store.commit("Notification/showError", 'Invalid form data');
            }
        },
        getAllTrekkingRoutes() {
            Http.get(API_URL + VERSION + "/trekking-routes/fetch-all")
                .then(response => {
                    this.trekkingRoutes = response.data.data;
                })

        },
        getAllGuides() {
            Http.get(API_URL + VERSION + "/guides")
                .then(response => {
                    this.guides = response.data.data;
                })

        },
        verifyTrekker(trekker, index) {
            let passport_number = trekker.passport_number;
            let visa_number = trekker.visa_number;
            if (!passport_number) {
                this.$store.commit('Notification/showError', 'Passport Number is required');
            }
            if (!visa_number) {
                this.$store.commit('Notification/showError', 'Visa Number or Submission ID is required');
            }

            if (passport_number && visa_number) {
                this.checkVisaValidity({
                    passport_number,
                    visa_number,
                    index
                }).then(() => {
                    this.$store.commit('Notification/showSuccess', 'Valid')
                }).catch((err) => {
                    this.$store.commit('Notification/showError', 'Invalid trekker information')
                })
            }
        },
        getAllPorters() {
            Http.get(API_URL + VERSION + "/porters")
                .then(response => {
                    this.porters = response.data.data;
                })
        },

        addTrekker() {
            this.trekkingData.trekkers.push({
                visa_number: "",
                passport_number: ''
            });
        },
        removeTrekker(index) {
            this.trekkingData.trekkers.splice(index, 1);
        },

        showValidity(document_type) {
            if (!document_type)
                return true;

            return document_type.split(" ").includes("passport");
        }
    },
    created() {
        // this.resetState();

        this.getAllTrekkingRoutes();
        this.getAllGuides();
        this.getAllPorters();
        Http.get(`${API_URL}${API_VERSION}` + '/dynamic-values-setup/fetch-all?key=occupations').then((response) => {
            this.occupations = response.data.map((item) => item.value).map(i => i.name);
            this.occupations.push('Others')
        });


        this.$store.dispatch('SingleTrekRequest/getCountries');
        if (!this.type)
            this.$store.dispatch('AuthUser/getTrekkingAgencyStatus');
    },
    watch: {
        "trekkingPermitData": function (val) {
            this.trekkingData = val;
        },
        "trekkingData.isExpedition": function (val) {
            if (!this.trekkingData.id)
                if (val) {
                    this.trekkingData.trekkers.pop()
                } else {
                    this.trekkingData.trekkers.push({
                        visa_number: "",
                        passport_number: "",
                        country: '',
                        name: ''
                    })
                }
        }
    }

};
</script>
